import { render, staticRenderFns } from "./aff-table.vue?vue&type=template&id=04d6b386"
import script from "./aff-table.vue?vue&type=script&lang=js"
export * from "./aff-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d6b386')) {
      api.createRecord('04d6b386', component.options)
    } else {
      api.reload('04d6b386', component.options)
    }
    module.hot.accept("./aff-table.vue?vue&type=template&id=04d6b386", function () {
      api.rerender('04d6b386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user-aff/aff-table.vue"
export default component.exports